import { apiFetch, readApiErrorMessage } from '../utils/apiClient';
import { LscApiError } from './api';
import type {
  CfbSchoolCatalogEntry,
  CfbSchoolCatalogGetResponse,
  CfbSchoolCatalogListResponse,
  CfbSchoolCatalogSearchResponse,
} from './cfbSchoolCatalogTypes';

async function catalogRequest<T>(path: string): Promise<T> {
  const response = await apiFetch(path);
  let body: T | { error?: string; message?: string } | null = null;
  try {
    body = (await response.json()) as T;
  } catch {
    body = null;
  }
  if (!response.ok) {
    const message =
      (body && typeof body === 'object' && 'message' in body && typeof body.message === 'string'
        ? body.message
        : null) ||
      (body && typeof body === 'object' && 'error' in body && typeof body.error === 'string'
        ? body.error
        : null) ||
      (await readApiErrorMessage(response)) ||
      `Request failed (${response.status})`;
    const code =
      body && typeof body === 'object' && 'error' in body && typeof body.error === 'string'
        ? body.error
        : undefined;
    throw new LscApiError(message, response.status, code);
  }
  return body as T;
}

export async function listCfbSchools(): Promise<{
  schools: CfbSchoolCatalogEntry[];
  count: number;
  catalog_version: string;
}> {
  const body = await catalogRequest<CfbSchoolCatalogListResponse>('/api/lsc/cfb/schools');
  return {
    schools: body.schools,
    count: body.count,
    catalog_version: body.catalog_version,
  };
}

export async function searchCfbSchools(query: string): Promise<{
  schools: CfbSchoolCatalogEntry[];
  count: number;
  catalog_version: string;
  query: string;
}> {
  const params = new URLSearchParams({ q: query });
  const body = await catalogRequest<CfbSchoolCatalogSearchResponse>(
    `/api/lsc/cfb/schools/search?${params.toString()}`
  );
  return {
    schools: body.schools,
    count: body.count,
    catalog_version: body.catalog_version,
    query: body.query,
  };
}

export async function getCfbSchool(schoolId: string): Promise<CfbSchoolCatalogEntry> {
  const body = await catalogRequest<CfbSchoolCatalogGetResponse>(
    `/api/lsc/cfb/schools/${encodeURIComponent(schoolId)}`
  );
  return body.school;
}
